export default __webpack_public_path__ + "static/media/mantl.9b29f426.svg";